import { useContext, type ComponentProps } from "react";

import { cn } from "../../lib/utils";
import { SelectCollectingContext } from "./SelectContext";

export type SelectLabelProps = ComponentProps<"div">;

export const SelectLabel = ({ className, ...props }: SelectLabelProps) => {
  const collecting = useContext(SelectCollectingContext);
  if (collecting) return null;

  return (
    <div
      data-slot="select-label"
      role="presentation"
      className={cn("px-2 py-1.5 text-xs text-muted-foreground", className)}
      {...props}
    />
  );
};
